import React from 'react'
import {
  OnboardingDrawer,
  useApplicationModals,
  useApplicationContext,
  hooks,
} from '@adc/ui-adc'
import { hooks as experimentHooks, getExperimentFlags } from '@adc/experiments'
import { authTypes } from '../../constants/statics'

const OnboardingDrawerContainer = props => {
  const modals = useApplicationModals()
  const { experiments } = useApplicationContext()
  const onboardingExperiments = [
    'ed203-newvisitslider_modallink',
    'ed-199-new_visitor_slider_time_to_get_started',
  ]
  const getABExperiments = (experimentsList, experiments) => {
    const experimentFlags = getExperimentFlags(experiments)
    return experimentsList.reduce((acc, experiment) => {
      return {
        ...acc,
        [experiment]: experimentHooks.useFeatureFlag(
          experimentFlags?.[experiment]
        ),
      }
    }, {})
  }

  const { useIsMobileHook } = hooks
  const isMobile = useIsMobileHook()
  const getStarted = () => {
    modals.open('authentication', { authInitialActive: authTypes.SIGNUP })
  }
  return (
    <OnboardingDrawer
      getStarted={getStarted}
      {...props}
      experiments={getABExperiments(onboardingExperiments, experiments)}
      isMobile={isMobile}
    />
  )
}

export default OnboardingDrawerContainer
